import React from "react";
import CardupdatrButton from "../page-components/shared/CardupdatrButton";

export default function Expired(props : { style?, buttonText?, statusCode, ssoUser, title, linkFunction }){

    return (
            <div style={{justifyContent: "center", alignItems: "center", flexDirection:"row", display:"flex", marginTop:"45vh"}}>
                <h1 className="next-error-h1" style={{margin: "0px 20px 0px 0px", padding: "0px 23px 0px 0px", fontSize: "24px", fontWeight: "500", borderRight: props.linkFunction ? "1px solid rgba(0, 0, 0, .3)" : ""}}>{props.statusCode ? props.statusCode : 500}</h1>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", verticalAlign: "middle", width: "190px"}}>
                        <h2 style={{fontSize: "14px", fontWeight: "normal", margin: "0px",
    padding: "0px"}}>
                            {props.title ? props.title : "An unexpected error occured."}
                        </h2>
                        {props.linkFunction ? <CardupdatrButton style={props.style ? Object.assign(props.style, {fontSize: "14px"}) : {fontSize: "14px"}} onClick={props.linkFunction} text={props.buttonText ? props.buttonText : "Done"}/> : null}
                </div>
            </div>
    )
}